<template>
  <aside class="
      md:w-64
      flex flex-col flex-shrink-0
      transition-all
      overflow-y-scroll
      duration-300
      bg-menu-bg-color
      text-menu-text-color
      h-full
    " :class="{ 'w-0 p-0 md:-ml-64': !isOpen, 'w-full p-4': isOpen }">
    <nav>
      <p class="md:text-base text-center mr-2 md:mr-8 md:hidden">
          {{ ___("SideNav|You are logged in as|content") }}:
          <span class="text-base md:text-xl">{{
              $page.props.accountName
          }}  <span v-if="$page.props.showCustomerNumber">({{ $page.props.customerNumber }})</span></span>
      </p>
      <div class="flex justify-between my-4" >
        <ManageEmployeeModal v-if="$page.props.isInvitationEnabled" class="md:hidden"/>
          <Btn type="button" @onClick="switchUser" v-if="$page.props.isAdminUser === true" class="md:w-full">
            {{ ___("SideNav|Switch User|content") }}
          </Btn>
           <Btn type="button" @onClick="switchUser" v-if="$page.props.mainAccountCanUseUserSwitcher"  class="md:w-full">
            {{ ___("SideNav|Switch User|content") }}
          </Btn>
      </div>
    
      <ul class="flex flex-col w-full list-none p-0 text-menu-font-size ">
        <li class="my-px">
          <Link @click="mobileToggle" href="/dashboard" class="
              flex flex-row
              items-center
              py-menu-line-height
              px-4
              rounded-customRadius
              border-custom border-transparent
              hover:border-accent-color w-full
              focus:outline-none
            " :class="
              $inertia.page.url.startsWith('/dashboard')
                ? 'bg-primary-color text-primary-text-color'
                : 'text-menu-text-color'
            ">
          <span class="flex items-center justify-center text-lg">
            <svg fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
              stroke="currentColor" class="h-6 w-6">
              <path
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6">
              </path>
            </svg>
          </span>
          <span class="ml-3">
            {{ ___("SideNav|Dashboard|content") }}</span></Link>
        </li>
        <li class="my-px" v-if="$page.props.showBlogResource">
          <Link @click="mobileToggle" href="/blogs" class="
              flex flex-row
              items-center
              py-menu-line-height
              px-4
              rounded-customRadius
              border-custom border-transparent
              hover:border-accent-color w-full
              focus:outline-none
            " :class="
              $inertia.page.url.startsWith('/blogs')
                ? 'bg-primary-color text-primary-text-color'
                : 'text-menu-text-color'
            ">
          <span class="flex items-center justify-center text-lg">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25" />
          </svg>

          </span>
          <span class="ml-3">
            {{ ___("SideNav|Blogs|content") }}</span></Link>
        </li>
        <li class="my-px" v-if="$page.props.isResourcesEnabled">
          <Link @click="mobileToggle" href="/resources" class="
              flex flex-row
              items-center
              py-menu-line-height
              px-4
              rounded-customRadius
              border-custom border-transparent
              hover:border-accent-color w-full
              focus:outline-none
            " :class="
              $inertia.page.url.startsWith('/resources')
                ? 'bg-primary-color text-primary-text-color'
                : 'text-menu-text-color'
            ">
          <span class="flex items-center justify-center text-lg">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 12.75V12A2.25 2.25 0 0 1 4.5 9.75h15A2.25 2.25 0 0 1 21.75 12v.75m-8.69-6.44-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z" />
          </svg>
          </span>
          <span class="ml-3">
            {{ ___("SideNav|Resources|content") }}</span></Link>
        </li>

        <li class="my-px"   v-if="($page.props.isShopShown && $page.props.user.show_shop_view) || ($page.props.isPipelineShown && $page.props.user.show_pipeline_view) ||($page.props.isDatatableEnabled && $page.props.user.show_datatable_view) || ($page.props.user.account_warehouses!=null && $page.props.user.account_warehouses.length>0)">
          <span class="
              flex
              headline
              text-sm text-menu-text-color
              px-4
              mt-4
              uppercase
            ">{{ ___("SideNav|Orders|content") }}</span>
        </li>
        <li class="my-px" v-if="$page.props.isShopShown && $page.props.user.show_shop_view">
          <Link @click="mobileToggle" href="/articles" class="
              flex flex-row
              items-center
              py-menu-line-height
              px-4
              rounded-customRadius
              border-custom border-transparent
              hover:border-accent-color w-full
              focus:outline-none
            " :class="
              $inertia.page.url.startsWith('/articles')
                ? 'bg-primary-color text-primary-text-color	'
                : 'text-menu-text-color'
            ">
          <span class="flex items-center justify-center text-lg">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
            </svg>
          </span>
          <span class="ml-3">{{ ___("SideNav|New Order|content") }}</span>
          </Link>
        </li>
        <li class="my-px" v-if="$page.props.isPipelineShown && $page.props.user.show_pipeline_view">
          <Link @click="mobileToggle" href="/pipeline" class="
              flex flex-row
              items-center
              py-menu-line-height
              px-4
              rounded-customRadius
              border-custom border-transparent
              hover:border-accent-color w-full
              focus:outline-none
            " :class="
              $inertia.page.url.startsWith('/pipeline')
                ? 'bg-primary-color text-primary-text-color	'
                : 'text-menu-text-color'
            ">
          <span class="flex items-center justify-center text-lg">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
              </path>
            </svg>
          </span>
          <span class="ml-3">{{ ___("SideNav|Pipeline|content") }}</span>
          <span class="
                ml-3
                w-12
                h-8
                px-1
                rounded-customRadius
                inline-flex
                justify-center
                items-center
                border border-primary-color
              " :class="[
                $inertia.page.url.startsWith('/pipeline')
                  ? 'bg-menu-bg-color text-menu-text-color'
                  : 'bg-primary-color text-primary-text-color',
              ]" v-if="$page.props.cartitems >= 1">
              <span v-if="$page.props.cartitems >= 999">
                999+
              </span>
              <span v-else>
                {{ $page.props.cartitems }}
              </span>
            </span>
          </Link>
        </li>
        <li class="my-px" v-if="$page.props.isDatatableEnabled && $page.props.user.show_datatable_view">
          <Link @click="mobileToggle" href="/datatable" class="
              flex flex-row
              items-center
              py-menu-line-height
              px-4
              rounded-customRadius
              border-custom border-transparent
              hover:border-accent-color
              focus:outline-none
            " :class="
              $inertia.page.url.startsWith('/datatable')
                ? 'bg-primary-color text-primary-text-color	'
                : 'text-menu-text-color'
            ">
            <span class="flex items-center justify-center text-lg">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
              </svg>
            </span>
            <span class="ml-3">{{ ___("SideNav|Datatable|content") }}</span>
          </Link>
        </li>
        <li class="my-px" v-if="$page.props.user.account_warehouses!=null && $page.props.user.account_warehouses.length>0">
         <Link  @click="mobileToggle" href="/warehouses" class="
             flex flex-row
             items-center
             py-menu-line-height
             px-4
             rounded-customRadius
             border-custom border-transparent
             hover:border-accent-color w-full
             focus:outline-none
           " :class="
             $inertia.page.url.startsWith('/warehouses')
               ? 'bg-primary-color text-primary-text-color '
               : 'text-menu-text-color'
           ">
         <span class="flex items-center justify-center text-lg">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
          </svg>
         </span>
         <span class="ml-3">{{ ___("SideNav|Warehouses|content") }}</span>
         </Link>
       </li>

       <template v-if="$page.props.isHelpdeskEnabled && $page.props.accountHelpdeskEnabled && $page.props.isHelpdeskPermissionsAllowed">
          <li class="my-px">
            <span class="flex headline text-sm text-menu-text-color px-4 mt-4 uppercase">{{
            ___("SideNav|Helpdesk|content") }}</span>
          </li>
          <li class="my-px">
            <Link @click="mobileToggle" href="/createticket" class="
                flex flex-row
                items-center
                py-menu-line-height
                px-4
                rounded-customRadius
                border-custom border-transparent
                hover:border-accent-color w-full
                focus:outline-none
              " :class="
                $inertia.page.url.startsWith('/createticket')
                  ? 'bg-primary-color text-white	'
                  : 'text-menu-text-color'
              ">
            <span class="
                  flex
                  items-center
                  justify-center
                  text-lg
                ">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
              </svg>
            </span>
            <span class="ml-3">{{
            ___("SideNav|Create Ticket|content")
            }}</span>
            </Link>
          </li>
          <li class="my-px">
            <Link @click="mobileToggle" href="/viewticket" class="
                flex flex-row
                items-center
                py-menu-line-height
                px-4
                rounded-customRadius
                border-custom border-transparent
                hover:border-accent-color w-full
                focus:outline-none
              " :class="
                $inertia.page.url.startsWith('/viewticket')
                  ? 'bg-primary-color text-white	'
                  : 'text-menu-text-color'
              ">
            <span class="
                  flex
                  items-center
                  justify-center
                  text-lg
                ">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
              </svg>
            </span>
            <span class="ml-3">{{ ___("SideNav|View Ticket|content") }}</span>
            </Link>
          </li>
        </template>
        

        <template v-if="!$page.props.showHistorySection">
          <li class="my-px" v-if="$page.props.isOrderViewShown ||$page.props.isShipmentViewShown || $page.props.isInvoiceViewShown || isQuotationViewShown()">
          <span class="
              flex
              headline
              text-sm text-menu-text-color
              px-4
              mt-4
              uppercase
            ">{{ ___("SideNav|Bookkeeping|content") }}</span>
        </li>
        <li class="my-px" v-if="$page.props.isOrderViewShown">
          <Link @click="mobileToggle" href="/orders" class="
              flex flex-row
              items-center
              py-menu-line-height
              px-4
              rounded-customRadius
              border-custom border-transparent
              hover:border-accent-color w-full
              focus:outline-none
            " :class="
              $inertia.page.url.startsWith('/orders')
                ? 'bg-primary-color text-primary-text-color	'
                : 'text-menu-text-color'
            ">
          <span class="flex items-center justify-center text-lg">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
            </svg>
          </span>
          <span class="ml-3">{{ ___("SideNav|Orders|content") }}</span>
          </Link>
        </li>
        <li class="my-px" v-if="$page.props.isShipmentViewShown">
          <Link @click="mobileToggle" href="/shipment" class="
              flex flex-row
              items-center
              py-menu-line-height
              px-4
              rounded-customRadius
              border-custom border-transparent
              hover:border-accent-color w-full
              focus:outline-none
            " :class="
              $inertia.page.url.startsWith('/shipment')
                ? 'bg-primary-color text-primary-text-color	'
                : 'text-menu-text-color'
            ">
          <span class="flex items-center justify-center text-lg">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" />
            </svg>
          </span>
          <span class="ml-3">{{ ___("SideNav|Shipment|content") }}</span>
          </Link>
        </li>
        <li class="my-px" v-if="$page.props.isInvoiceViewShown">
          <Link @click="mobileToggle" href="/invoices" class="
              flex flex-row
              items-center
              py-menu-line-height
              px-4
              rounded-customRadius
              border-custom border-transparent
              hover:border-accent-color w-full
              focus:outline-none
            " :class="
              $inertia.page.url.startsWith('/invoices')
                ? 'bg-primary-color text-primary-text-color	'
                : 'text-menu-text-color'
            ">
          <span class="flex items-center justify-center text-lg">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M14.121 15.536c-1.171 1.952-3.07 1.952-4.242 0-1.172-1.953-1.172-5.119 0-7.072 1.171-1.952 3.07-1.952 4.242 0M8 10.5h4m-4 3h4m9-1.5a9 9 0 11-18 0 9 9 0 0118 0z">
              </path>
            </svg>
          </span>
          <span class="ml-3">{{ ___("SideNav|Invoices|content") }}</span>
          </Link>
        </li>
         <li class="my-px" v-if="isQuotationViewShown()">
          <Link @click="mobileToggle" href="/quotation" class="
              flex flex-row
              items-center
              py-menu-line-height
              px-4
              rounded-customRadius
              border-custom border-transparent
              hover:border-accent-color w-full
              focus:outline-none
            " :class="
              $inertia.page.url.startsWith('/quotation')
                ? 'bg-primary-color text-primary-text-color	'
                : 'text-menu-text-color'
            ">
          <span class="flex items-center justify-center text-lg">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V13.5zm0 2.25h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V18zm2.498-6.75h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V13.5zm0 2.25h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V18zm2.504-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zm0 2.25h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V18zm2.498-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zM8.25 6h7.5v2.25h-7.5V6zM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 002.25 2.25h10.5a2.25 2.25 0 002.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0012 2.25z" />
            </svg>

          </span>
          <span class="ml-3">{{ ___("SideNav|Quotation|content") }} </span>
          </Link>
        </li>
        </template>

        <template v-if="$page.props.platformSupport || $page.props.technicalSupport">
          <li class="my-px">
            <span class="
                flex
                headline
                text-sm text-menu-text-color
                px-4
                mt-4
                uppercase
              ">{{ ___("SideNav|Account|content") }}</span>
          </li>
          <li class="my-px" v-if="$page.props.platformSupport">
            <Link @click="mobileToggle" href="/platformsupport" class="
                flex flex-row
                items-center
                py-menu-line-height
                px-4
                rounded-customRadius
                border-custom border-transparent
                hover:border-accent-color w-full
                focus:outline-none
              " :class="
                $inertia.page.url.startsWith('/platformsupport')
                  ? 'bg-primary-color text-primary-text-color	'
                  : 'text-menu-text-color'
              ">
            <span class="flex items-center justify-center text-lg">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </span>
            <span class="ml-3">{{
            ___("SideNav|Platform Support Page|content")
            }}</span>
            </Link>
          </li>
          <li class="my-px" v-if="$page.props.technicalSupport">
            <Link @click="mobileToggle" href="/technicalsupport" class="
                flex flex-row
                items-center
                py-menu-line-height
                px-4
                rounded-customRadius
                border-custom border-transparent
                hover:border-accent-color w-full
                focus:outline-none
              " :class="
                $inertia.page.url.startsWith('/technicalsupport')
                  ? 'bg-primary-color text-primary-text-color	'
                  : 'text-menu-text-color'
              ">
            <span class="flex items-center justify-center text-lg">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </span>
            <span class="ml-3">{{
            ___("SideNav|Technical Support Page|content")
            }}</span>
            </Link>
          </li>
        </template>
        <li class="my-px" v-if="$page.props.privacypages > 0">
          <Link as="button" @click="mobileToggle" href="/privacypolicy" class="
              flex flex-row
              items-center
              py-menu-line-height
              px-4
              rounded-customRadius
              border-custom border-transparent
              hover:border-accent-color w-full
              focus:outline-none
            " :class="
              $inertia.page.url.startsWith('/privacypolicy')
                ? 'bg-primary-color text-primary-text-color	'
                : 'text-menu-text-color'
            ">
          <span class="flex items-center justify-center text-lg">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
          </span>
          <span class="ml-3">{{
          ___("SideNav|Privacy Policy|content")
          }}</span>
          </Link>
        </li>
        <li class="my-px" v-if="$page.props.termspages > 0">
          <Link @click="mobileToggle" href="/termsandconditions" class="
              flex flex-row
              items-center
              py-menu-line-height
              px-4
              rounded-customRadius
              border-custom border-transparent
              hover:border-accent-color w-full
              focus:outline-none
            " :class="
              $inertia.page.url.startsWith('/termsandconditions')
                ? 'bg-primary-color text-primary-text-color	'
                : 'text-menu-text-color'
            ">
          <span class="flex items-center justify-center text-lg">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
            </svg>
          </span>
          <span class="ml-3">{{
          ___("SideNav|Terms and Conditions|content")
          }}</span>
          </Link>
        </li>
        <li class="my-px" v-if="$page.props.userHasForms">
          <Link @click="mobileToggle" href="/feedback" class="
              flex flex-row
              items-center
              py-menu-line-height
              px-4
              rounded-customRadius
              border-custom border-transparent
              hover:border-accent-color w-full
              focus:outline-none
            " :class="
              $inertia.page.url.startsWith('/feedback')
                ? 'bg-primary-color text-primary-text-color	'
                : 'text-menu-text-color'
            ">
          <span class="flex items-center justify-center text-lg">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </span>
          <span class="ml-3">{{ ___("SideNav|Feedback|content") }}</span>
          </Link>
        </li>

        <ul v-if="$page.props.externalLinks.length > 0">
          <li class="my-px">
            <span class="
                flex
                headline
                text-sm text-menu-text-color
                px-4
                mt-4
                uppercase
              ">{{ ___("SideNav|More links|content") }}</span>
          </li>
          <li v-for="(link, l) in $page.props.externalLinks" :key="l" class="my-px">
            <a v-if="link.layout == 'custom_field_link'"
            class="
                flex flex-row
                items-center
                py-menu-line-height
                px-4
                rounded-customRadius
                border-custom border-transparent
                hover:border-accent-color w-full
              " :href="link.value" target="_blank">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
              {{ link.attributes.description }}

            </a>
            <a v-else-if="(link.layout == 'url_link')" class="
                flex flex-row
                items-center
                py-menu-line-height
                px-4
                rounded-customRadius
                border-custom border-transparent
                hover:border-accent-color w-full
              " :href="link.attributes.url" target="_blank">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
              {{ link.attributes.description }}
            </a>
          </li>
        </ul>
      </ul>
      <div v-if="$page.props.isAdminUser === true" class="md:hidden">
          <LanguageSwitcher userType="admin" :selectedLang="$page.props.userlanguage" />
      </div>

      <footer class="text-menu-text-color text-center text-xs mt-3">
        &copy; {{ ___("SideNav|Footer Text|content") }} v{{ $page.props.version }}
      </footer>
    </nav>
  </aside>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue'
import SearchSelect from "@/Components/SearchSelect";
import Btn from "@/Components/Btn";
import LanguageSwitcher from "@/Components/LanguageSwitcher";
import ManageEmployeeModal from "@/Components/ManageEmployeeModal";

export default {
  props: {
    isOpen: Boolean,
  },
  components: {
    Btn,
    Link,
    LanguageSwitcher,
    SearchSelect,
    ManageEmployeeModal
  },
  methods: {
    mobileToggle() {
      if (window.innerWidth >= 768) {
        return;
      } else {
        this.$emit("closeNav", false);
      }
    },
    switchUser() {
      this.$inertia.get("/selectuser");
    },
    isQuotationViewShown(){
      let globalQuotationShown = this.$page.props.isQuotationShown;
      if(globalQuotationShown){
          if(this.$page.props.user.show_quotation){
            return true;
          }
          else{
            return false;
          }
      }
      else{
        return false;
      }
    }
  },
};
</script>
